import gql from 'graphql-tag';
import { type GetDefaultRatesQuery } from 'src/app/shared/graphql/agreements/default-rates-query.graphql.autogenerated';

export type GetDefaultRatesQueryResult = GetDefaultRatesQuery['defaultRates'];

export const GetDefaultRatesDocument = gql`
  query getDefaultRates {
    defaultRates {
      defaultPerKmRate
      ndiaPriceGuideTravelRate
    }
  }
`;
